import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { useStoryBibleStore } from "src/stores/storyBibleStore";
import HoverTippable from "../../../StoryBible/HoverTippable";
import { StyledButton } from "./styles";

const PreflightLoaderButton = () => {
  const isStoryBibleActive = useStoryBibleStore((state) => state.isActive);
  const labels = React.useMemo(
    () => (isStoryBibleActive ? ["Checking scenes...", "Checking Story Bible...", "Estimating Word Count..."] : ["Checking scenes...", "Estimating Word Count..."]),
    [isStoryBibleActive]
  );

  const [label, setLabel] = useState(labels[0]);

  useEffect(() => {
    setLabel(labels[0]);
  }, [labels]);

  useEffect(() => {
    const interval = setInterval(() => {
      setLabel((prevLabel) => {
        const currentIndex = labels.indexOf(prevLabel);
        const nextIndex = (currentIndex + 1) % labels.length;
        return labels[nextIndex];
      });
    }, 5000);
    return () => clearInterval(interval);
  }, [labels]);

  return (
    <HoverTippable
      generateDisabled={true}
      generateDisabledMessage="Please wait while we run the preflight..."
      id="button-container-preflight"
    >
      <StyledButton
        id="button-preflight"
        disabled
      >
        <SVG src="/assets/loader.svg" />
        <p>{label}</p>
      </StyledButton>
    </HoverTippable>
  );
};

export default PreflightLoaderButton;
